const getAffId = (s, affid) => {
  const affId = s.getQueryParamValue(affid, true);
  if (typeof affId !== "undefined" && affId !== "") {
    return affId;
  }
};

const getXAffId = (s) => {
  const xAffId = s.getQueryParamValue("xaffid", true);
  if (typeof xAffId !== "undefined" && xAffId !== "") {
    return xAffId;
  }
};

export default (affid) => {
  const s = window && window.s;
  return getAffId(s, affid) || getXAffId(s) || null;
};
